import { useTranslations } from '@vocab/react';
import { Box, Stack, Text } from 'braid-design-system';

import CareerGuideLogo from '../../icons/IconCareerGuide/IconCareerGuide';

import translations from './.vocab';

const CareerGuideNudge = () => {
  const { t } = useTranslations(translations);

  return (
    <Box
      borderRadius="large"
      background="infoLight"
      padding="medium"
      marginBottom="xsmall"
    >
      <Stack space="xsmall">
        <CareerGuideLogo />
        <Text>
          {t(
            'SEEK has partnered with GO1, a trusted online training platform. All you need is a SEEK Profile.',
          )}
        </Text>
      </Stack>
    </Box>
  );
};

export default CareerGuideNudge;
